import React, { Component } from "react";
import { SelectDropdown, InfoBox, DatePicker, TimePicker, Tooltip } from "../widgets";
import "./NewDispatch.css";
import moment from "moment-timezone";
import DispatchControlDropDown from "./DispatchControlDropDown";
import StrategyDropDown from "./StrategyDropDown";
import AuthRequired from "../../containers/AuthRequired";
import Permissions, { allPermissions } from "../../permissions";

class NewDispatch extends Component {
  handleStartDateChange = startDate => {
    let nextDate = this.props.startDateTime.clone();
    nextDate.date(startDate.date());
    nextDate.month(startDate.month());
    nextDate.year(startDate.year());
    nextDate.tz(this.props.timezone);

    this.props.handleStartDateTimeChange(nextDate);
  };

  handleStartTimeChange = nextStartDateTime => {
    this.props.handleStartDateTimeChange(nextStartDateTime);
  };

  handleEndTimeChange = nextEndDateTime => {
    const duration = moment.duration(nextEndDateTime.diff(this.props.startDateTime));

    if (duration < 0) {
      return;
    }

    this.props.handleDurationChange(duration.asSeconds());
  };

  render() {
    if (!this.props.powerstations && this.props.allowPowerstationEdit) {
      return (
        <InfoBox
          type="warning"
          message="You must create a Virtual Power Plant before you can dispatch."
        />
      );
    }

    let powerstation_options = [];
    // we're coming in from the VPP screen
    if (this.props.powerstation && !this.props.powerstations) {
      powerstation_options = [
        {
          label: this.props.powerstationId,
          value: this.props.powerstationName,
        },
      ];
    } else {
      powerstation_options = this.props.powerstations.map(p => {
        return { label: p.name, value: p.id };
      });
    }

    const endDateTime = this.props.startDateTime.clone();
    endDateTime.add(this.props.duration, "seconds");
    return (
      <>
        {!this.props.startDateTime.isSame(moment().tz(this.props.timezone), "day") &&
        this.props.showMarketData &&
        !this.props.readOnly ? (
          <InfoBox
            type="warning"
            message="Predictions for future dates are likely to be inaccurate and market price predictions are unavailable."
          />
        ) : null}
        {!this.props.startDateTime.isSame(moment().tz(this.props.timezone), "day") &&
        !this.props.showMarketData &&
        !this.props.readOnly ? (
          <InfoBox
            type="warning"
            message="Predictions for future dates are likely to be inaccurate."
          />
        ) : null}
        {this.props.multipleRegions && this.props.showMarketData && !this.props.readOnly ? (
          <InfoBox type="warning" message="This Virtual Power Plant spans multiple NEM regions." />
        ) : null}
        <div className="new-dispatch-info">
          {this.props.allowPowerstationEdit || this.props.readOnly ? (
            <div>
              Add a new dispatch for
              <SelectDropdown
                readOnly={this.props.readOnly}
                placeholder="Virtual Power Plant"
                value={this.props.powerstation}
                onChange={val => this.props.onPowerstationChange(val)}
                options={powerstation_options}
                tooltipTitle="Virtual Power Plant"
                tooltipContent="The Virtual Power Plant you wish to dispatch. Whilst a VPP can contain a mix of dispatchable and non-dispatchable systems only those that are dispatchable will have this event applied. All predictions and estimates here only include those systems that are dispatchable."
              />
            </div>
          ) : null}
          {this.props.powerstation ? (
            <>
              <div>
                from
                <DatePicker
                  readOnly={this.props.readOnly}
                  placeholder="start date"
                  value={this.props.startDateTime.clone()}
                  onChange={this.handleStartDateChange}
                  minDate={moment()}
                  dateFormat="d MMMM"
                  asInline
                />
                at
                <TimePicker
                  readOnly={this.props.readOnly}
                  placeholder="start time"
                  dateTime={this.props.startDateTime}
                  onChange={this.handleStartTimeChange}
                  timezone={this.props.timezone}
                  minuteStep={5}
                  asInline
                  showNow
                />
                until
                <TimePicker
                  readOnly={this.props.readOnly}
                  placeholder="end time"
                  dateTime={endDateTime}
                  offsetFromDateTime={this.props.startDateTime}
                  onChange={this.handleEndTimeChange}
                  timezone={this.props.timezone}
                  minuteStep={5}
                  asInline
                />
                {allPermissions(this.props.userPermissions, [
                  Permissions.fleet.dispatches.powerFactor,
                  Permissions.fleet.dispatches.strategy,
                ]) ? (
                  <br />
                ) : null}
                to
                {this.props.constraints ? (
                  <>
                    <DispatchControlDropDown
                      readOnly={this.props.readOnly}
                      onChangeRealPowerP={this.props.onChangeRealPowerP}
                      onChangePowerFactor={this.props.onChangePowerFactor}
                      onChangePowerFactorLeadLag={this.props.onChangePowerFactorLeadLag}
                      realPowerP={this.props.realPowerP}
                      powerFactor={this.props.powerFactor}
                      powerFactorLeadLag={this.props.powerFactorLeadLag}
                      realPowerPMin={this.props.constraints.realPowerPMin}
                      realPowerPMax={this.props.constraints.realPowerPMax}
                      realPowerAvailable={this.props.constraints.realPowerAvailable}
                      powerFactorMin={this.props.constraints.powerFactorMin}
                      powerFactorMax={this.props.constraints.powerFactorMax}
                      powerFactorAvailable={this.props.constraints.powerFactorAvailable}
                      powerFactorLeadLagConstraint={this.props.constraints.powerFactorLeadLag}
                      powerFactorConstraintMessage={
                        this.props.constraints.powerFactorConstraintMessage
                      }
                      powerFactorAllowed={this.props.powerFactorAllowed}
                      leadLagAllowed={this.props.leadLagAllowed}
                    />
                    <AuthRequired permission={Permissions.fleet.dispatches.strategy}>
                      {this.props.realPowerP === 0 ? null : (
                        <>
                          {this.props.readOnly ? "," : null}
                          <StrategyDropDown
                            readOnly={this.props.readOnly}
                            strategy={this.props.strategy}
                            onStrategyChange={this.props.onStrategyChange}
                          />
                        </>
                      )}
                    </AuthRequired>
                  </>
                ) : (
                  " lockout"
                )}
                <Tooltip large id="dispatches.new.action" />
              </div>
            </>
          ) : null}
          {this.props.powerstation ? (
            <div className="customer-msg">
              <div className="title">Customer message:</div>
              {this.props.realPowerP !== 0 ? (
                this.props.readOnly ? (
                  <div>
                    {this.props.customerAppMessage ? (
                      <span className="ro">{this.props.customerAppMessage}</span>
                    ) : (
                      <span className="lockout-message">Default message only</span>
                    )}
                  </div>
                ) : (
                  <div
                    className="edit-container link"
                    onClick={this.props.showCustomerAppMessageEdit}
                  >
                    <span className="customer-msg-summary">
                      {this.props.customerAppMessage ? (
                        this.props.customerAppMessage
                      ) : (
                        <span className="lockout-message">Default message only</span>
                      )}
                    </span>
                    <span className="fa fa-chevron-right edit-icon" />
                  </div>
                )
              ) : (
                <div className="lockout-message">
                  {!this.props.constraints || !this.props.constraints.realPowerAvailable
                    ? "Messages are not sent for power factor only dispatches."
                    : "Messages are not sent for lockouts."}
                </div>
              )}
              <Tooltip id="dispatches.new.customerMessage" />
            </div>
          ) : null}
        </div>
      </>
    );
  }
}

export default NewDispatch;
